import { SET_FAQ_EXPANDED_NODE_IDS, SET_FAQ_GROUP, SET_FAQ_GROUP_MAP, SET_FAQ_SCROLL_TO_ID } from './types'
import { FAQGroup } from '../../interfaces/faq';
import { FQAState } from 'redux/reducers/faq';
import { AppDispatch } from 'redux/store';

const updateGroupMap = ({ parentId: _parentId, group: _group, groupMap }: Pick<FQAState, 'group' | 'groupMap'> & {parentId:string}) => {
  if (_group) {
    for (let i = 0; i < _group.length; i++) {
      const { id, group } = _group[i]
      groupMap.set(id, _parentId)
      updateGroupMap({ parentId: id, group, groupMap })
    }
  }
}

const setFaqGroupMap = (groupMap: Map<string, string>) => ({
  type: SET_FAQ_GROUP_MAP,
  groupMap
})

export const setFaqGroup = (group: FAQGroup[]) => {
  return (dispatch: AppDispatch, _:any) => {
    dispatch({
      type: SET_FAQ_GROUP,
      group
    })

    const groupMap = new Map()
    updateGroupMap({ parentId: null, group, groupMap })
    dispatch(setFaqGroupMap(groupMap))
  }
}
export const setFaqExpandedNodeIds = (nodeIds:string[]) => ({
  type: SET_FAQ_EXPANDED_NODE_IDS,
  nodeIds
})

export const setFaqScrollToId = (scrollToId:string) => ({
  type: SET_FAQ_SCROLL_TO_ID,
  scrollToId
})
